export default {
    title: 'Mapa do Amor',
    link: 'mapa-do-amor',

    customContent: {
        relevantAspects: {
            title: 'Aspectos astrológicos - harmônicos e desafiadores',
            fluid: 'Suas vantagens e estabilidades',
            tense: 'Suas interferências e pontos de atenção',

            relations: {
                conjunction: '{planet1} x {planet2}',
                sextil: '{planet1} x {planet2}',
                trigon: '{planet1} x {planet2}',
                oposition: '{planet1} x {planet2}',
                quadrature: '{planet1} x {planet2}'
            }
        },

        astrologicHouses: {
            childhood: 'Infância e raízes',
            insecurities: 'Inseguranças, fragilidades, medo da solidão',
            marriage: 'Casamento e convivência',
            others: 'Outras casas astrológicas ',
            relationships: 'Buscas, flertes e início de relacionamentos',
            sexuality: 'Sexualidade, fusão e rituais',

            noPositions: 'Não há astros posicionados nessa casa.',
            house: 'Casa {house}'
        }
    },

    paywallOTS: {
        hero: {
            alt: 'Ilustração do Mapa do Amor com um coração de cristal rosa e elementos astrológicos. Banner com 50% OFF exclusivo para assinantes.'
        },

        limitedOffer: {
            subscriber: 'OFERTA EXCLUSIVA PARA ASSINANTES',
            nonSubscriber: 'OFERTA EXCLUSIVA, 50% OFF',
            valentinesDay: "OFERTA DE VALENTINE'S DAY"
        },

        mainTitle: 'Pare de sofrer por amor!',
        mainSubtitle:
            'Sua análise personalizada te mostra exatamente o que mudar para ter relacionamentos que funcionam.',

        countdown: {
            label: 'A promoção acaba em:'
        },

        payment: {
            callout: {
                subscriber: 'DESCONTO BÔNUS DE CLIENTE PREMIUM',
                nonSubscriber: 'OFERTA EXCLUSIVA DE LANÇAMENTO',
                subscriberValentines: 'DESCONTO BÔNUS DE CLIENTE PREMIUM',
                nonSubscriberValentines: 'PROMOÇÃO ESPECIAL'
            },
            from: '<del>De {fullPrice}</del> por apenas',
            price: '<span></span><span>{value}</span>',
            installments: '<span>{installments}x</span><span>{installmentValue}</span>',
            cash: 'sem juros ou à vista <b>{cashPrice}</b>',
            details: 'Acesso vitalício ⭐ | Liberação Imediata 🚀 | Garantia de 7 dias 🏆 | Compra segura 🔒',
            detailsDesktop: 'Acesso vitalício ⭐ | Liberação Imediata 🚀<br/>Garantia de 7 dias 🏆 | Compra segura 🔒',
            bonus: '+BÔNUS: CUPOM DE 50% OFF NO PREMIUM 🎁'
        },

        paymentButtons: {
            installments: 'Parcelamento em até {installments}x sem juros',
            card: {
                prefix: 'Comprar Mapa do Amor com',
                bold: 'Cartão'
            },
            pix: {
                prefix: 'Comprar Mapa do Amor com',
                bold: 'Pix'
            }
        },

        benefits: {
            title: 'VOCÊ VAI TER ACESSO ILIMITADO A:',
            items: {
                pages: '120 páginas de conteúdo didático e ilustrado.',
                analysis: 'Análise personalizada exclusivamente para o seu Mapa Astral.',
                patterns: 'Descubra seus padrões emocionais e comportamentais.',
                vulnerabilities: 'Como identificar vulnerabilidades e evitar armadilhas emocionais.',
                personalizedAdvice: 'Conselhos personalizados para a sua idade.',
                spheres: 'As diversas esferas do relacionamento: amor, amizade, paixão e sexualidade.',
                history: 'História dos relacionamentos e influências biológicas.',
                conditioning: 'Condicionamentos sociais e antropológicos.',
                children: 'Filhos no Mapa Astral.',
                bonus: 'Bônus - Dicas e reflexões sobre términos, carência e relações tóxicas.'
            }
        },

        forWho: {
            title: 'Para quem é o Mapa do Amor?',
            subtitle: 'O Mapa do Amor é direcionado e personalizado para todos os que desejam se conhecer melhor!',
            items: {
                0: {
                    bold: 'Solteiros:',
                    text: 'Pare de atrair as pessoas erradas e encontre seu par ideal.'
                },
                1: {
                    bold: 'Relacionamentos desgastados:',
                    text: 'Como sair do ciclo de brigas e incertezas.'
                },
                2: {
                    bold: 'Redescoberta para casais:',
                    text: 'Acenda a chama e construa uma conexão inabalável a dois.'
                },
                3: {
                    bold: 'Curiosidade e autoconhecimento:',
                    text: 'O manual definitivo para você dominar suas emoções.'
                }
            }
        },

        testimonials: {
            title: 'Mais de <strong>35 mil</strong> vidas já foram transformadas. A próxima transformação vai ser a sua!',
            subtitle: 'Veja o que dizem as pessoas que já estão vivendo relacionamentos incríveis:',
            items: {
                0: {
                    text: 'Chocada com a precisão! O Mapa me mostrou exatamente por que eu sempre caía em furada. Agora sinto que recuperei meu brilho e não aceito migalha de ninguém',
                    name: 'Angela',
                    sign: 'Pisciana'
                },
                1: {
                    text: 'Estávamos numa fase difícil, quase desistindo. O mapa ajudou a clarear as coisas e trouxe uma união que não tínhamos faz tempo. Valeu cada centavo.',
                    name: 'Thais',
                    sign: 'Ariana'
                }
            }
        },

        secrets: {
            title: '5 segredos do Mapa do Amor que vão mudar sua forma de se relacionar para sempre:',
            items: {
                0: {
                    title: 'O Código de Autossabotagem:',
                    text: 'Descubra o padrão invisível que destrói suas relações e saiba como vencê-lo.'
                },
                1: {
                    title: 'O Filtro Antifrustrações:',
                    text: 'Como diferenciar, nos primeiros dias, quem é um "amor possível" de quem é apenas uma "cilada emocional".'
                },
                2: {
                    title: 'O Desbloqueio da Mente:',
                    text: 'Encontre seu propósito e pare de aceitar migalhas emocionais por medo da solidão.'
                },
                3: {
                    title: 'A Escala da Vulnerabilidade:',
                    text: 'Identifique suas travas ocultas e desbloqueie seu magnetismo pessoal. Aqui, suas vulnerabilidades viram força para nunca mais ser manipulada(o).'
                },
                4: {
                    title: 'A Chave da Conexão Blindada:',
                    text: 'Use ferramentas práticas para construir uma conexão inquebrável, sem jogos ou inseguranças.'
                }
            },
            cta: 'Quero conhecer os segredos!'
        },

        comparison: {
            title: 'Veja a diferença que o conhecimento do seu mapa personalizado faz na sua vida:',
            without: {
                title: 'Sem o Mapa do Amor',
                items: {
                    0: 'Continua atraindo os mesmos tipos de pessoas',
                    1: 'Perde oportunidades com pessoas especiais',
                    2: 'Fica presa em relacionamentos tóxicos',
                    3: 'Vive com medo de abandono',
                    4: 'Sente que não é digna de ser amada',
                    5: 'Investe em pessoas erradas',
                    6: 'Não sabe mais como fugir do sofrimento'
                }
            },
            with: {
                title: 'Com o Mapa do Amor',
                items: {
                    0: 'Quebra ciclos destrutivos',
                    1: 'Identifica pessoas certas para você',
                    2: 'Constrói relacionamentos saudáveis e duradouros',
                    3: 'Paz de espírito e segurança sobre o futuro',
                    4: 'Descobre seu merecimento e se valoriza muito mais',
                    5: 'Reconhece sinais de alerta',
                    6: '<strong>Aprende como nunca mais sofrer por ninguém!</strong>'
                }
            }
        },

        subscriberAdvantages: {
            discount: 'Garanta agora sua análise personalizada com <b>{discount}% de desconto!</b>',
            anchor: 'Quero meu Mapa do Amor com {discount}% OFF',
            title: 'VANTAGENS PARA ASSINANTES',
            description:
                'Além de <strong>desconto em todos os produtos</strong> de compra única, assinantes tem <strong>acesso a todas as ferramentas ilimitadas:</strong> adicionais do Mapa Astral, Mapas Extras, Compatibilidades, Ciclo Lunar, Tarot e Biorritmo!'
        },

        terms: {
            text: 'Ao comprar produtos do Astrolink você concorda com os nossos',
            link: 'Termos de Uso'
        },

        result: {
            success: {
                title: 'Compra Efetuada!',
                email: 'Você receberá uma confirmação no seu e-mail de cadastro',
                guideDiscount: 'Guia 2026 (30% de desconto)',
                subscribe: {
                    title: 'Seu Cupom de Desconto',
                    discount:
                        'Assine o Astrolink Premium em qualquer plano com 50% de desconto! Cupom válido por 30 dias',
                    subscribeButton: 'Veja nossos Planos Premium',

                    app: {
                        title: 'Torne-se Premium',
                        discount:
                            'Assine o Astrolink Premium e garanta seu acesso a ferramentas e descontos exclusivos!'
                    }
                },
                guide: {
                    title: 'O Mapa do Amor já está disponível!',
                    message: 'Acesse quando quiser pelo menu <em>Explorar</em>',
                    readButton: 'Leia seu Mapa do Amor'
                }
            },
            error: {
                title: 'Erro ao efetuar a compra 😕',
                message:
                    '<strong>{userName}</strong>, infelizmente ocorreu um erro, pedimos que você verifique as informações inseridas e se o problema persistir, nos contate através do nosso <a href="{supportUrl}">suporte</a>',
                backButton: 'Voltar'
            }
        }
    }
};
